<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>助力活动>新建助力</div>
		<div class="newADcontent">
			<div class="adContent">
				<p style="font-size: 14px;margin-top: 10px;"><span
						style="color: red;">*</span>提示：拼团一旦开始则不能更改上述信息，仅可延长结束时间和开启/关闭模拟成团</p>
				<div class="title" style="margin-top: 20px;">
					<div class="blue"></div>
					<div style="flex: 1;">基本设置</div>
				</div>
				<el-form ref="form" :model="addDataList" label-width="150px" label-position="left">
					<el-form-item label="关联商品/服务">
						<el-button type="text" style="color: #999;"><i class="el-icon-plus"></i>添加券/券包</el-button>
					</el-form-item>
					<div class="title" style="margin-top: 20px;">
						<div class="blue"></div>
						<div style="flex: 1;">助力信息</div>
					</div>
					<el-form-item label="助力活动时间">
						<el-date-picker size="small" v-model="addDataList.time" type="datetimerange"
							format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="助力人数">
						<el-input v-model="addDataList.count" style="width: 300px;" size="small"
							placeholder="输入助力人数"></el-input>
					</el-form-item>
					<el-form-item label="助力权益">
						<p>
							<el-radio v-model="addDataList.legalRight" label="1">是</el-radio><span
								style="margin-left: 20px;color: #999;">参与助力活动用户均可获得权益</span>
						</p>
						<p>
							<el-radio v-model="addDataList.legalRight" label="2">否</el-radio><span
								style="margin-left: 20px;color: #999;">仅活动发起人获得权益</span>
						</p>
					</el-form-item>
					<el-form-item label="助力时限">
						<p><el-radio v-model="addDataList.timeLimit" label="1">24小时</el-radio></p>
						<p><el-radio v-model="addDataList.timeLimit" label="2">48小时</el-radio></p>
						<p><el-radio v-model="addDataList.timeLimit" label="3">自定义</el-radio>
							<el-select style="width: 100px;margin:0 20px;" size="small"
								v-model="addDataList.timeLimitCount">
								<el-option v-for="item in addDataList.timeLimitCountList" :key="item.value"
									:label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</p>
					</el-form-item>
					<div class="title" style="margin-top: 20px;">
						<div class="blue"></div>
						<div style="flex: 1;">分享设置</div>
					</div>
					<el-form-item label="分享标题">
						<el-input v-model="addDataList.title" size="small" style="width: 500px;" maxlength="24"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="分享描述">
						<el-input v-model="addDataList.describe" size="small" style="width: 500px;" maxlength="36"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="分享图片">
						<div style="display: flex;">
							<div style="width: 130px; height: 130px">
								<el-image style="width: 130px; height: 130px" :src="addDataList.img" fit="fill">
									<div slot="error" class="image-slot">
										<img src="../../../assets/sa.png" />
									</div>
								</el-image>
							</div>
							<div style="width: 130px; height: 130px;margin-left: 20px;">
								<el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
									:show-file-list="false">
									<el-button type="primary" size="small">选择图片</el-button>
								</el-upload>
								<p style="color: red;font-size: 12px;line-height: 20px;margin-top: 10px;">
									图片格式为：bmp，jpeg，jpg，gif，尺寸1:1，不可大于1M。</p>
							</div>
						</div>
					</el-form-item>
					<el-form-item>
						<el-button>取消</el-button>
						<el-button type="primary" style="margin-left: 20px;">保存</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				addDataList: {
					time: "",
					count: "",
					legalRight: "",
					timeLimit: "",
					timeLimitCountList: [{
						value: "30",
						label: "30分钟"
					}, {
						value: "60",
						label: "30分钟"
					}, {
						value: "120",
						label: "2个小时"
					}],
					title: "",
					describe: "",
					img: ""
				}
			}
		}
	}
</script>

<style lang="less" scoped>
	p {
		margin: 0;
		padding: 0;
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.newADcontent {
		display: flex;

		// & > div{
		// 	display: inline-block;
		// }
		.adContent {
			flex: 2;
		}

		.adExamples {
			flex: 1;
			padding: 0 30px;

			img {
				width: 300px;
				height: auto;
			}
		}
	}
</style>